module.exports = __webpack_public_path__ + "img/adobe-workout.aaa1e722.png";